import { render, staticRenderFns } from "./select-requirement.vue?vue&type=template&id=d8e3e98e&"
import script from "./select-requirement.vue?vue&type=script&lang=js&"
export * from "./select-requirement.vue?vue&type=script&lang=js&"
import style0 from "./select-requirement.vue?vue&type=style&index=0&id=d8e3e98e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports